import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import React, { useState } from "react";
import {
  Star as StarIcon,
  Description as DescriptionIcon,

} from "@material-ui/icons";

import {
  Radio,
  RadioGroup,
} from "../../../../../components/RadioButton/RadioButtonModal";
import { observer } from "mobx-react-lite";
import Sugestoes from "./Sugestoes";
import Modelos from "./Modelos";
import { TypeModalEnumTGO } from "../../../../../stores/TGO.store";
import classNames from "classnames";
import MinimizeIcon from "../../../../../components/Icon/MinimizeIcon";

const tipoListagem = [
  { name: "Sugestões", icon: StarIcon, value: "sugestoes", selected: true },
  { name: "Modelos", icon: DescriptionIcon, value: "modelos", selected: false },
];

const ListagemLateral = observer((props) => {
  const { classes, TGOStore } = props;
  const { typeModal } = TGOStore;

  const [minimizado, setMinimizado] = useState(false);

  const onChangeTipoListagem = (tipoListagem) => {
    TGOStore.tipoListagemSelecionada = tipoListagem;

    if (tipoListagem === "sugestoes") {
      TGOStore.changeFieldsStore({
        sugestoesPagAtual: 0,
        sugestoes: [],
      });

      TGOStore.findAllGuiaServicoTussViewQuantidadeUso({
        pageableDTO: {
          pageSize: 6,
          pageNumber: TGOStore.sugestoesPagAtual,
          sortDir: "DESC",
          sortField: "quantidadeUso",
        },
      });
    } else {
      TGOStore.changeFieldsStore({
        modelosPagAtual: 0,
        modelos: [],
      });

      TGOStore.findAllGuiaServicoModelo({
        searchDTO: {
          ativo: true,
        },
        pageableDTO: {
          pageSize: 10,
          pageNumber: TGOStore.modelosPagAtual,
          sortDir: "DESC",
          sortField: "quantidadeUso",
        },
      });
    }
  };

  return (
    <div
      className={classNames(classes.lateralSugestoes, minimizado ? classes.minimizadoWidth : classes.maximizadoWidth)}
    >
      {minimizado ? (
        <div className={classes.minimizado}>
          <span className={classes.textoVertical}>Sugestões e Modelos</span>
          <MinimizeIcon
              id="prt-gtg-ico-exp"
              className={classes.minimizeICon}
              onClick={() => setMinimizado(false)}
              inverted
          />
        </div>
      ) : (
        <>
          <div className={classes.header}>
            <span className={classes.titulo}>Sugestões e Modelos</span>
            <MinimizeIcon
              id="prt-gtg-ico-min"
              className={classes.minimizeICon}
              onClick={() => setMinimizado(true)}
            />
          </div>

          <div className={classes.radioButton}>
            <RadioGroup name="tipoListagem" />
            {typeModal === TypeModalEnumTGO.TGO_MODAL ? (
              tipoListagem.map((item, index) => (
                <Radio
                  id={`prt-gtg-rad-tip-${index}`}
                  key={item.value}
                  value={item.value}
                  className={classes.botoesSugestoesModelosProntos}
                  checked={TGOStore.tipoListagemSelecionada === item.value}
                  icon={item.icon}
                  onChange={() => onChangeTipoListagem(item.value)}
                  label={item.name}
                />
              ))
            ) : (
              <div className={classes.tituloSugestao}>
                <StarIcon style={{ marginRight: 10 }} />
                Sugestões
              </div>
            )}
          </div>

          {TGOStore.tipoListagemSelecionada === "sugestoes" && <Sugestoes />}
          {TGOStore.tipoListagemSelecionada === "modelos" && (
            <Modelos onChangeTipoListagem={onChangeTipoListagem} />
          )}
        </>
      )}
    </div>
  );
});


const styles = {
  lateralSugestoes: {
    display: "flex",
    flexDirection: "column",
    background: "#26ACA9",
    borderRadius: "0 10px 10px 0",
    alignItems: "center",
    overflowY: "hidden",
    transition: "width 0.3s ease",
  },
  minimizadoWidth: {
    minWidth: "50px",
  },
  maximizadoWidth: {
    minWidth: "330px",
  },
  textoVertical: {
    fontSize: '18px !important',
    writingMode: "vertical-lr",
    transform: "rotate(180deg)",
  },
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    padding: "16px 0px",
    alignItems: "center",
  },
  titulo: {
    color: "#fff",
    fontSize: '18px !important',
    fontWeight: "bold",
  },
  minimizeICon: {
    cursor: "pointer",
  },
  radioButton: {
    margin: "8px 0 16px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  botoesSugestoesModelosProntos: {
    display: "flex",
    flexDirection: "row",
    minWidth: "auto",
    fontWeight: "normal !important",
    background: "rgba(0, 0, 0, 0.1)",
    "&.active": {
      background: "rgba(0, 0, 0, 0.5)",
    },
  },
  tituloSugestao: {
    display: "flex",
    flexDirection: "row",
    minWidth: "auto",
    fontWeight: "normal !important",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 87,
    color: "#fff",
    width: "100%",
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 12px",
  },
  minimizado: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    height: "100%",
    display: "flex",
    gap: "18px",
    justifyContent: "end",
    alignItems: "center",
    cursor: "pointer",
    color: "#fff",
    fontWeight: "bold",
    padding: "24px 0",
  },
};


const ListagemLateralWithStyles = withStyles(styles)(ListagemLateral);
export default inject("TGOStore")(ListagemLateralWithStyles);
